module.exports = __webpack_public_path__ + "img/GAME_RAINWINDOW.a4955989.png";